/* eslint-disable no-unused-vars */
import $axios from './axios'
import store from '@/store'
import { isDev, isTest, isDebug, ut_encryptXor } from '../utils'
const path = require('path')

const baseURL_mx = 'https://mx.muccybook.com'

const formatData = obj => {
  if (obj instanceof FormData) return obj
  let data = new FormData()
  for (let k in obj) obj[k] != undefined && data.append(k, obj[k])
  return data
}

//用户服务api地址的BaseURL
const getBaseURL_apiuser = () => {
  let baseURL = $axios.defaults.baseURL
  let host = (baseURL.match(/^(http[s]?:)?\/\/[^/]*/i) || [])[0] || ''
  let pathname = baseURL.replace(host, '')
  let baseURL_apiuser = host + path.resolve(pathname, '../apiuser') //PS: path.resolve 会将 // 变成 /，所以要加一个host
  //本地开发调试时使用指定的用户服务api地址的BaseURL，根据需要开启
  // if (isDev()) {
  //   baseURL_apiuser = '//test-mxapi.cgyouxi.com/apiuser'
  // }
  return baseURL_apiuser
}

//工具服务api地址的BaseURL
const getBaseURL_apitool = () => {
  let baseURL = $axios.defaults.baseURL
  let host = (baseURL.match(/^(http[s]?:)?\/\/[^/]*/i) || [])[0] || ''
  let pathname = baseURL.replace(host, '')
  let baseURL_apitool = host + path.resolve(pathname, '../apitool')
  //本地开发调试时使用指定的工具服务api地址的BaseURL，根据需要开启
  // if (isDev()) {
  //   baseURL_apitool = '//test-mxapi.cgyouxi.com/apitool'
  // }
  return baseURL_apitool
}

//获取橙光api地址的BaseURL
const getBaseURL_org = () => {
  let prefix = '//'
  if (isTest()) prefix = '//test-'
  // else if (isDebug()) prefix = '//debug-'       //注释则表示debug环境使用线上接口
  let baseURL_org = prefix + 'www.66rpg.com'
  return baseURL_org
}

//获取木夕json地址的BaseURL
const getBaseURL_json = () => {
  let prefix = '//'
  // if (isTest()) prefix = '//test-'   //目前所有环境的json都用线上的
  let baseURL_json =
    prefix + `mx.${location.host.indexOf('muccybook.com') != -1 ? 'muccybook.com' : '66rpg.com'}`
  return baseURL_json
}

// 辅助方法
export const _ut = {
  formatData,
  getBaseURL_apiuser,
  getBaseURL_org,
  getBaseURL_apitool,
  getBaseURL_json
}

//作品详情页-默认整页加载
export function getPageDetail(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/get_page_by_details',
    method: 'POST',
    data: params,
    ...config
  })
}

//作品详情页-默认整页加载
export function getVersion(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/getVersion',
    method: 'POST',
    params,
    ...config
  })
}

// 账号（暂为手机号）密码登录
export function loginByPsw(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/login/common/login',
    method: 'post',
    data: params,
    noToken: true,
    ...config
  })
}

//第三方授权登录接口
export function loginByThird(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/login/thirdPartyUserLogin',
    method: 'post',
    data: params,
    noToken: true,
    ...config
  })
}

//查询登录账户类型
export function findOne(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/login/findOne',
    method: 'get',
    params,
    ...config
  })
}

//用户绑定或换绑手机号时发送的验证码短信
export function sendCodeForPhone(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/account/bind/getCode',
    method: 'get',
    params: {
      auth: ut_encryptXor({ ...params, uuid: store.getters.vx_get_uuid })
    },
    ...config
  })
}

//快捷登录时发送的验证码短信
export function sendCodeForLogin(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/login/message/send/login',
    method: 'get',
    params: {
      auth: ut_encryptXor({ ...params, uuid: store.getters.vx_get_uuid })
    },
    noToken: true,
    ...config
  })
}

//首次快捷登录后设置密码的接口
export function axiosSetPsw(params) {
  return $axios({
    url: '/apiuser/v1/web/user/reset/sec/options',
    method: 'post',
    data: params,
  })
}

// 发送验证码前的图片校验
export function axiosGetImgVerif() {
  return $axios({
    url: '/apiuser/v1/web/user/verifyImage/getImgVerify',
    method: 'get',
  })
}

/**
 * 发送验证码前的图片校验
 * @param {Object} params
 * {
    moveLength：  X坐标
 * }
 */
export function axiosCheckImgVerif(params) {
  return $axios({
    url: '/apiuser/v1/web/user/verifyImage/check',
    method: 'post',
    data: formatData(params),
    noToken: true
  })
}

//用户忘记密码时发送的验证码短信
export function sendCodeForPsw(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/reset/message/get/pass',
    method: 'get',
    params: {
      auth: ut_encryptXor({ ...params, uuid: store.getters.vx_get_uuid })
    },
    noToken: true,
    ...config
  })
}

//找回密码时的验证
export function verifyCodeForPsw(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/reset/sec/find',
    method: 'post',
    params,
    noToken: true,
    ...config
  })
}

//重置密码
export function resetPsw(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/reset/sec/new/password',
    method: 'post',
    params,
    noToken: true,
    ...config
  })
}

//手机号快捷登录
export function loginByCode(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v1/web/user/login/quick/login',
    method: 'post',
    data: params,
    noToken: true,
    ...config
  })
}

//微信登录拿到code后换取token
export function wxLoginCallback(params, config = {}) {
  // 获取用户服务接口BaseURL
  let baseURL = getBaseURL_apiuser()
  return $axios({
    baseURL,
    url: '/v2/web/user/login/wxLoginCallback',
    method: 'get',
    params,
    noToken: true,
    ...config
  })
}

//关注作者
export function followAuthor(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/follow_author',
    method: 'POST',
    data: params,
    ...config
  })
}

//取消关注作者
export function cancelFollowAuthor(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/cancel_follow_author',
    method: 'POST',
    data: params,
    ...config
  })
}

//用户收藏接口
export function setCollection(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/set_collection',
    method: 'POST',
    data: params,
    ...config
  })
}

//取消收藏接口
export function cancelCollection(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/detail/cancel_collection',
    method: 'POST',
    data: params,
    ...config
  })
}

//消费水晶购买选项
export function buyOption(params, config = {}) {
  return $axios({
    url: '/community/v1/qingcheng/community/engine/deduct_crystal',
    method: 'POST',
    data: params,
    ...config
  })
}

//编推页顶部推荐轮播图，视频(新)
export function getIndexGameDisPlayList(params, config = {}) {
  return $axios({
    url: '/community/indexDisPlay/getIndexGameDisPlayList?',
    method: 'get',
    params,
    ...config
  })
}

// 首页头部展示封面图的JSON
export function getJsonHomeThumbs(params, config = {}) {
  return $axios({
    baseURL: baseURL_mx,
    url: '/cms/cms_json/t_1/60.json?v=' + Date.now(),
    method: 'get',
    params,
    noToken: true,
    ...config
  })
}

/**
 * 发送橙光验证码
 * @param {*} cgUid      橙光用户ID
 * @param {*} mobile     手机号
 */
export function axiosUserGetIndentity(mobile) {
  let formData = new FormData()
  formData.append('cgUid', 'xxx')
  formData.append('mobile', mobile)
  return $axios({
    url: '/apitool-v2/api/cgUser/userGetIndentity',
    method: 'post',
    data: formData
  })
}

/**
 * 绑定橙光账号
 * @param {*} cgUid      橙光用户ID
 * @param {*} mobile     手机号
 * @param {*} code       验证码
 */
export function axiosBindAccountSecurity(mobile, code) {
  let formData = new FormData()
  formData.append('cgUid', 'xxx')
  formData.append('mobile', mobile)
  formData.append('code', code)
  return $axios({
    url: `/apitool-v2/api/cgUser/bindAccountSecurity`,
    method: 'post',
    data: formData,
    isToken: true
  })
}

// 获取验证码
export function axiosGetCode(mobile, typeCode) {
  return $axios({
    url: `/apiuser/v1/web/user/account/bind/getCode`,
    method: 'get',
    params: {
      auth: ut_encryptXor({ mobile, typeCode, uuid: store.getters.vx_get_uuid })
    }
  })
}

// 校验绑定手机号时的验证码是否正确
export function axiosPhoneBindVerif(phone, validateCode, typeCode) {
  let formData = new FormData()
  formData.append('phone', phone)
  formData.append('validateCode', validateCode)
  typeCode && formData.append('typeCode', typeCode);
  return $axios({
    url: '/apiuser/v1/web/user/account/bind/phoneCodeVerification',  // phoneBindVerif
    method: 'post',
    data: formData
  })
}

// 绑定手机号
export function axiosBindMobile(phone, password, typeCode) {
  let formData = formatData({
    platformType: 0,  //  绑定类型 0:手机号、1:微信|2:QQ、3:微博、4:橙光
    platformValue: phone, // 手机号
    password, // 手机号
    typeCode, // 国际区号
  })
  // formData.append('cmsFlag', 1)  //cms编辑操作标识，可省略验证码与密码
  // return $axios({
  //   url: '/community/v1/web/community/account/bind',
  //   method: 'post',
  //   data: formData
  // })
  return axiosBindV3(formData)
}

// 搜索作品
export function axiosGetGamebyKeyword(keyword, page) {
  return $axios({
    url: 'community/v1/qingcheng/community/search/get_game_by_keyword',
    method: 'post',
    noToken: true,
    data: {
      keyword,
      page,
      pageSize: 10
    }
  })
}

//  判断木夕用户是否实名制认证
export function axiosCheckPublishProjectPermission() {
  return $axios({
    url: '/apiuser/v1/web/user/account/handle/checkPublishProjectPermission',
    method: 'get'
  })
}

//  获取歌曲列表
export function axiosGetPlayerList(page = 1, pageSize = 10) {
  return $axios({
    url: `community/v1/web/community/authenticMusic/getAuthenticMusicByPage?page=${page}&pageSize=${pageSize}`,
    method: 'get',
    noToken: true
  })
}

//获取用户绑定关系列表信息（包含绑定手机号）
export function axiosGetBindInfo(params) {
  return $axios({
    url: '/apiuser/v1/web/user/account/bind/getInfo',
    method: 'get',
    params
  })
}

// 获取橙光账号昵称
export function axiosGetCgName(params) {
  return $axios({
    url: '/apitool-v2/api/cgUser/getCgName',
    method: 'get',
    params
  })
}

//绑定橙光账号
export function axiosBindV3(params) {
  return $axios({
    url: '/apiuser/v1/web/user/account/bind/v3',
    method: 'post',
    data: params
  })
}

// 合并橙光账号
export function axiosMergeAccount(params) {
  return $axios({
    url: '/apiuser/v1/web/user/account/bind/merge',
    method: 'post',
    data: params
  })
}


// 获取页面控制信息
export function axiosGetPageControlInfos() {
  return $axios({
    url: '/community/page/getPageControlInfos',
    method: 'get'
  })
}


// 查询页面置灰信息接口
export function getHomePageGrayingInfos() {
  return $axios({
    url: '/community/page/getHomePageGrayingInfos',
    method: 'get'
  })
}

export let getEditPageData = (data) => {
  return $axios({
    method: "post",
    url: "/community/v1/qingcheng/community/index/get_page_by_editor_default",
    data
  })
};

//编推页New&Tending
export let getEditNT = (data) => {
  // return axios.post('/v2/qingcheng/community/index/getNewAndTendingGameInfo', qs.stringify(data), {notToLogin: true});
  return $axios({
    method: "post",
    url: '/community/v1/web/community/homePage/getNewLaneWorks',
    data
  })
}
//根据作品标签加载信息（V1版，正式目前在用!）
export let getEditDatabyType = (data) => {
  return $axios({
    method: 'post',
    url:'/community/v1/qingcheng/community/index/get_page_by_type',
    data
  });
};

export const axiosGetMessage = (params) => {
  return $axios({
    method: 'get',
    url:'/community/v1/web/community/jobInfo/getJobInfoByPage',
    params
  });
}
